// @flow

import _, { has, isEqual } from 'lodash';
import React from 'react';

import VideoLayout from '../../../../../modules/UI/videolayout/VideoLayout';
import { getConferenceNameForTitle } from '../../../base/conference';
import { connect, disconnect } from '../../../base/connection';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n';
import { connect as reactReduxConnect } from '../../../base/redux';
import { setColorAlpha } from '../../../base/util';
import { Chat } from '../../../chat';
import { MainFilmstrip, ScreenshareFilmstrip, StageFilmstrip } from '../../../filmstrip';
import { CalleeInfoContainer } from '../../../invite';
import { LargeVideo } from '../../../large-video';
import { LobbyScreen } from '../../../lobby';
import { getIsLobbyVisible } from '../../../lobby/functions';
import { ParticipantsPane } from '../../../participants-pane/components/web';
import Prejoin from '../../../prejoin/components/web/Prejoin';
import { isPrejoinPageVisible } from '../../../prejoin/functions';
import { toggleToolboxVisible } from '../../../toolbox/actions.any';
import { fullScreenChanged, showToolbox } from '../../../toolbox/actions.web';
import { JitsiPortal, Toolbox } from '../../../toolbox/components/web';
import { LAYOUT_CLASSNAMES, getCurrentLayout } from '../../../video-layout';
import { maybeShowSuboptimalExperienceNotification } from '../../functions';
import {
    AbstractConference,
    abstractMapStateToProps
} from '../AbstractConference';
import type { AbstractProps } from '../AbstractConference';

import ConferenceInfo from './ConferenceInfo';
import { default as Notice } from './Notice';

declare var APP: Object;
declare var interfaceConfig: Object;

// CUSTOM
const { socket_endpoint } = Config;
import Config from '../../../customise/config';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3, tourGuideActions } from '../../../customise/constant';
import StudentWaitingPage from "../../../customise/student/StudentWaiting"
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import {
    ghostList,
    stopRecording,
    setConferenceJoined,
    setWaitingScreen,
    setHybridSession,
    setAudioGhostConnect,
    setLobbyStatus,
    setRecording,
    setStemRecording,
    showToastPopup,
    setDeviceUsers,
    setTeacherWillWait,
    setRoomUsers,
    setStudentSecondModerator,
    setData,
    setUserLoginData, // CUSTOM
    connectAudioGhost,
    setWaitingScreenStatus
} from '../../../customise/redux/tool-webjam/actions';
import Loader from 'react-loader';
import axios from 'axios';
import { socketOn, socketEmit } from "../../../../../socket";
import { setTileView } from '../../../video-layout/actions.any';
import {
    pinParticipant,
    getParticipantCount,
    grantModerator,
    getLocalParticipant,
    isLocalParticipantModerator,
    PARTICIPANT_ROLE,
    getRemoteParticipants,  // CUSTOM
} from '../../../base/participants';
import { ALLOWED_CONNECTION, CONFERENCE_KICK_TIMER, CONFERENCE_KICK_TIMER_BREAK, Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import { toggleLobbyMode } from '../../../lobby/actions.any';
import { clearNotifications, hideNotification, NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../../notifications';
import {
    disconnectRoom,
    StopRecordingConference,
    DisconnectModerator,
    toggletoastModal,
    DisconnectMultiModerator
} from "../../../customise/custom/toolbar/recording-function";
import { _ValidateIPaddress, _startConference, calculateTimeDiff, getStore, PANNING_VAR, filterRemoteParticipant, getBaseConfig, dispatch, isSocialMobileApp, InvitedUserConfirmFlag } from "../../../customise/Utils";
import { messages } from '../../../customise/welcome-dashboard/messages';
import { Translate } from '../../../webjam/language';
import { sendData } from '../../../webjam/websocket';
import { getDeviceUserName, setAudioChannelAdditionalSetting, setAudioStereo, setAvilableUserIP, setDuetUserId, setRecordingModalAction, setRecordingModalCount } from '../../../customise/redux/tool-webjam-v2/actions';
import { endConferenceA, getDeviceStatus, getOrganizationList, saveDuetLog, saveUnClaimedRoomReq, getUserLocation, checkRoomSessionApi } from '../../../customise/welcome-dashboard/Request.d';
import { AutoChangeCircleSlider } from '../../../customise/custom/toolbar/recording-streaming';
import toast from 'react-simple-toasts';
import ModalHandler from '../../../customise/custom/ModalHandler';
import Checkbox from '@atlaskit/checkbox';
import { statsEmitter } from '../../../connection-indicator/statsEmitter';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { getActiveSession } from '../../../recording';
import { getPublicIp } from '../../../webjam/helper';
import { setIsEventRequestingLoader, setShowDevicePreConnection, setTourGuideType } from '../../../customise/redux/tool-webjam-v3/actions';
import { SaveLog } from '../../../customise/Utils'
import { makeHostRoomStatus } from '../../../customise/custom/components/HelperComponent';
import { getMySubscription } from '../../../customise/welcome-dashboard/paymentRequest';
import { setPrejoinPageVisibility } from '../../../prejoin/actions.web';
import { setVolume, togglePinStageParticipant } from '../../../filmstrip/actions.web';  // CUSTOM
import jwt_decode from "jwt-decode";
import { ct } from '../../../customise/constant-Utils';
import { getParticipantsPaneOpen } from '../../../participants-pane/functions';
import { MEDIA_TYPE, VIDEO_MUTISM_AUTHORITY, setAudioMuted, setVideoMuted } from '../../../base/media';
import { muteLocal } from '../../../video-menu/actions.any';
import { PushSpinner } from '../../../customise/custom/components/PushSpinner';

if (["https://web.realtimeaudio.com", "http://live.matchmysound.com", "https://live.duetpartner.com", "https://web.oneclickwebcam.com"].indexOf(window.location.origin) != -1) {
    if (CURRENT_ROOM_NAME == "dev-testing-room" || CURRENT_ROOM_NAME.indexOf("dev-testing-room") != -1) {

    } else {
        console.log = () => { }
    }
}

// END

/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange'
];

/**
 * The type of the React {@code Component} props of {@link Conference}.
 */
type Props = AbstractProps & {

    /**
     * The alpha(opacity) of the background.
     */
    _backgroundAlpha: number,

    /**
     * The CSS class to apply to the root of {@link Conference} to modify the
     * application layout.
     */
    _layoutClassName: string,

    /**
     * The config specified interval for triggering mouseMoved iframe api events.
     */
    _mouseMoveCallbackInterval: number,

    /**
     *Whether or not the notifications should be displayed in the overflow drawer.
     */
    _overflowDrawer: boolean,

    /**
     * Name for this conference room.
     */
    _roomName: string,

    /**
     * If lobby page is visible or not.
     */
    _showLobby: boolean,

    /**
     * If prejoin page is visible or not.
     */
    _showPrejoin: boolean,

    dispatch: Function,
    t: Function
}

/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference<Props, *> {
    _onFullScreenChange: Function;
    _onMouseEnter: Function;
    _onMouseLeave: Function;
    _onMouseMove: Function;
    _onShowToolbar: Function;
    _onVidespaceTouchStart: Function;
    _originalOnMouseMove: Function;
    _originalOnShowToolbar: Function;
    _setBackground: Function;

    // CUSTOM
    state = {
        modCount: true,
        showNewRoomModal: false,
        ipNewroom: '',
        isLobbyDisabledRequested: false,
        musicModeSent: false,
        usersArr: [],
        selectedIndex: sessionStorage.getItem("selectedIndex") ? parseInt(sessionStorage.getItem("selectedIndex")) : 1,
        selectedPrevPanConf: PANNING_VAR.NO_PANNING,
        authTokenStatus: '',
        studentWillWait: false,
        musicModeStatusChange: false,
        localTimeStarted: false,
        connectionMessage: false,
        connectionErrorMessage: false,
        conferenceKickTimer: 0,
        errorMessage: '',
        bandwidthShow: true,
        connectionErrorMessageType: "",
        time: {},
        showBandwidthModal: true,
        internetLostPopup: true,
        showToolBoxPanel: true,
        roomSessionInterval: {
            status: false,
            time: 0
        }
    }
    // END

    /**
     * Initializes a new Conference instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);

        const { _mouseMoveCallbackInterval } = props;

        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._originalOnMouseMove = this._onMouseMove;

        this._onShowToolbar = _.throttle(
            () => this._originalOnShowToolbar(),
            100,
            {
                leading: true,
                trailing: false
            });

        this._onMouseMove = _.throttle(
            event => this._originalOnMouseMove(event),
            _mouseMoveCallbackInterval,
            {
                leading: true,
                trailing: false
            });

        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
        this._onVidespaceTouchStart = this._onVidespaceTouchStart.bind(this);
        this._setBackground = this._setBackground.bind(this);
        // CUSTOM
        this._onStatsUpdated = this._onStatsUpdated.bind(this);
        // END
    }

    /**
     * Start the connection and get the UI ready for the conference.
     *
     * @inheritdoc
     */
    componentDidMount() {
        document.title = `${this.props._roomName} | ${interfaceConfig.APP_NAME}`;
        // CUSTOM
        // this._start();
        // this.enableMicVideo()

        let willAuthorize = getBaseConfig("willAuthorize")

        if (willAuthorize == true) {
            this.setState({
                studentWillWait: true
            })
        }

        let { authVerifyToken, teacherWaitTimer } = this.props;

        this.setState({
            authTokenStatus: authVerifyToken?.type
        })

        if (authVerifyToken?.type == "join") {
            setTimeout(function () {
                _startConference();
            }, teacherWaitTimer)
        }

        socketOn("moderator_connected", (data) => {
            const { tokenDecodedData, authOrganization, getLocalParticipant, conferenceJoined } = this.props;
            const {
                jitsiId,
                organization,
                organization_id,
                roomName
            } = data;

            if (getLocalParticipant.id != jitsiId && conferenceJoined == false) {
                if (organization == authOrganization.domain
                    && organization_id == authOrganization._id
                    && roomName == tokenDecodedData.roomName) {

                    setTimeout(function () {
                        window.location.reload()
                    }, 6000)
                }
            }
        })

        socketOn("moderator_disconnected", (data) => {
            const { tokenDecodedData, authOrganization, conferenceJoined } = this.props;
            const {
                organization,
                organization_id,
                roomName
            } = data;

            if (conferenceJoined == true) {
                if (organization == authOrganization.domain
                    && organization_id == authOrganization._id
                    && roomName == tokenDecodedData.roomName) {

                    let willDisconnect = true;
                    let rel = this.musicModeCalculation()

                    if (rel != undefined) {
                        willDisconnect = rel
                    }

                    if (willDisconnect) {
                        toast(ct("messages.teacherDisconnect", "messages"), Constant.App.ToastTime.LongCloseTime);
                        setTimeout(function () {
                            window.location.href = window.location.origin;
                        }, 3000)
                    }
                }
            }
        })

        // FOR STREAM
        // document.getElementById('beepOne').play();
        axios.get(Constant.App.ServerUrl + "/ghost-user-ip.json").then(response => {
            APP.store.dispatch(ghostList(response.data.data));
        }).catch(error => {
            console.log("Invalid ghostList Request Found =>", error);
        });

        socketOn("hybrid_session_return", (data) => {
            const { usersData } = this.props;
            if (data.location == CURRENT_ROOM_LOCATION) {
                if (usersData) {
                    APP.store.dispatch(setHybridSession(data.status, "hybrid_session_return"));
                    if (data.hasOwnProperty("removeElementId")) {
                        let ghostId = data.removeElementId

                        try {
                            var elements = document.querySelectorAll('audio[id^="remoteAudio_' + ghostId + '"]');
                            console.log("ghost ids list  socket ", elements)
                            if (elements.length > 0) {
                                console.log("ghost id will be removed  socket")
                                setTimeout(function () {
                                    dispatch(setVolume(ghostId, 0))
                                    console.log("volume down yes from 2 of ghost user")
                                    elements[0].muted = true;
                                    elements[0].setAttribute("muted", true);
                                }, 4000)
                            }
                        } catch (e) {
                            console.log("hybrid id error ", e)
                        }

                        dispatch(connectAudioGhost({
                            audioGhostId: null,
                            isConnectedAudioGhost: false
                        }));
                    }
                }
            }
        })

        // CUSTOM: GHOST USER EVENT HANDLING
        socketOn("conference_started", (data) => {
            const { isWaiting, paidRoomDetail, userLoginData } = this.props;
            this.setState({ modCount: false });
            if (isWaiting) {
                setTimeout(() => {
                    // HIDE WAITING SCREEN
                    APP.store.dispatch(setWaitingScreen(false));
                    APP.store.dispatch(setWaitingScreenStatus(false));
                    dispatch(setUserLoginData({
                        ...userLoginData,
                        isRoomStarted: true
                    }, 9))
                    // TO CONNECT CONFERENCE
                    if (!APP.conference.isJoined()) {
                        APP.store.dispatch(setPrejoinPageVisibility(false, 6));
                        if (userLoginData.user.id && userLoginData.user.is_invited == true && (paidRoomDetail.passwordProtected == true || (paidRoomDetail.isRoomPaid && userLoginData.isPaid == false))) {
                            // CONFERENCE WILL NOT START UNLESS USER PAY OR ENTERED THE PASSWORD                             
                        } else {

                            _startConference(9);
                        }
                    }
                }, 3000);
            }
        });
        //END
        socketOn("conference_ended", (data) => {
            // TO DISCONNECT CONFERENCE (call hangup)
            let { isLogout } = this.props;
            let willDisconnect = true;
            let hasMusicRoom = sessionStorage.getItem("claimedUserD");
            if (hasMusicRoom) {
                try {
                    let musicUserDetail = JSON.parse(hasMusicRoom);
                    if (musicUserDetail?.roomName && musicUserDetail?.roomLocation && musicUserDetail?.time) {
                        if (calculateTimeDiff(musicUserDetail.time, messages.musicModeTimeLimit)) {
                            if (CURRENT_ROOM_LOCATION == musicUserDetail.roomLocation) {
                                willDisconnect = false;
                            }
                        }
                    }
                } catch (e) {
                    console.log('conference_ended claimedUserD error =>', e)
                }
            }

            let hasMusicModeRoom = localStorage.getItem("musicModeUser");
            if (hasMusicModeRoom) {
                try {
                    let _musicUserDetail = JSON.parse(hasMusicModeRoom);
                    if (_musicUserDetail?.roomName && _musicUserDetail?.roomLocation && _musicUserDetail?.time) {
                        if (calculateTimeDiff(_musicUserDetail.time, messages.musicModeTimeLimit)) {
                            if (CURRENT_ROOM_LOCATION == _musicUserDetail.roomLocation) {
                                willDisconnect = false;
                            }
                        }
                    }
                } catch (e) {
                    console.log('conference_ended musicModeUser error =>', e)
                }
            }

            if (willDisconnect) {
                // APP.store.dispatch(disconnect(true));
                APP.store.dispatch(disconnect(true));
                let socialAllowed = getBaseConfig("socialAllowed");
                if (socialAllowed == true && !isLogout) {
                    if (isSocialMobileApp()) {
                        window.parent.location.href = getBaseConfig("appReferrerUrl");
                        return false;
                    } else {
                        window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
                    }
                }
            }
        });

        // GHOST USER EVENT HANDLING
        socketOn("change_streaming_user_view_return", (data) => {
            const {
                ghostList,
                publicIp,
                roomorIpAddress,
                _iAmRecorder,
            } = this.props;

            // let demoList = ['abc', 'efg', '203.129.220.82'];
            // let ghostfound = ghostList.find(p => p === publicIp);
            if (_iAmRecorder && (data.roomName.toLowerCase() == roomorIpAddress || data.roomName.toLowerCase() == CURRENT_ROOM_NAME)) {
                APP.store.dispatch(setTileView(data.tileView));
            }
        });

        // GHOST USER EVENT HANDLING
        socketOn("highlight_streaming_user_thumbnail_return", (data) => {
            const {
                ghostList,
                publicIp,
                roomorIpAddress,
                _iAmRecorder,
            } = this.props;

            // let demoList = ['abc', 'efg', '203.129.220.82'];
            // let ghostfound = ghostList.find(p => p === publicIp);
            // if (ghostfound && (data.roomName.toLowerCase() == roomorIpAddress)) {
            if (_iAmRecorder && (data.roomName.toLowerCase() == roomorIpAddress || data.roomName.toLowerCase() == CURRENT_ROOM_NAME)) {
                if (data.filmStripeLayout) {
                    APP.store.dispatch(togglePinStageParticipant(data.pinId));
                } else {
                    APP.store.dispatch(pinParticipant(data.pinned ? null : data.pinId));
                }
                // APP.store.dispatch(pinParticipant(data.pinned ? null : data.pinId));
            }
        });

        // STEP 1 - IF - IF ADMIN ENTER CLAIMED, THEN CONTROL LOBBY  BY MODERATOR
        // STEP 1 - ELSE - AUDIO GHOST USER HANDLING TO CONTROL LOBBY DISABLE BY MODERATOR
        socketOn("moderator_grant_return", (data) => {
            const { location } = data;
            const { localParticipantRole, roomorIpAddress, dispatch } = this.props;
            const { lobbyEnabled } = this.props;
            let roomUrl = CURRENT_ROOM_LOCATION;

            // Hide lobby notification when audio ghost join the conference
            if (data.hasOwnProperty("userType")) {
                if (data.userType == "Recorder") {
                    dispatch(setAudioGhostConnect(true));
                    setTimeout(function () {
                        dispatch(setAudioGhostConnect(false));
                    }, 35000)
                }
            }

            let eventTimer = 3000;
            if (data.hasOwnProperty("time")) {
                eventTimer = data.time;
            }

            if (location != roomUrl) {
                return false;
            }

            if (data.hasOwnProperty("isAdminRight") && location == roomUrl) {
                // Provide jitsi admin right to admin (isAdmin)
                // if (PARTICIPANT_ROLE.MODERATOR == localParticipantRole && location == window.location.origin + roomorIpAddress) {
                if (data.hasOwnProperty("jitsiUser")) {
                    dispatch(grantModerator(data.jitsiUser));
                }
                let _thi = this;

                // ENABLE LOBBY 
                let lob_timer = data.lobby ? 3000 : 500
                setTimeout(() => {
                    _thi.setState({ lobbyEnabled: data.lobby });
                    if (data.lobby) {
                        dispatch(setLobbyStatus(true));
                    }
                    dispatch(toggleLobbyMode(data.lobby));
                }, lob_timer);

                // if (data.hasOwnProperty("jitsiUser") ) {
                //     dispatch(grantModerator(data.jitsiUser));
                // } else {
                //     this.setState({ lobbyEnabled: data.lobby });
                //     dispatch(toggleLobbyMode(data.lobby));
                // }
            } else if (data.hasOwnProperty("teacherAccess")) {
                let roomUrl_ = CURRENT_ROOM_LOCATION;
                if (roomUrl_ == location) {
                    const { getLocalParticipant, conferenceJoined, tokenDecodedData } = this.props;
                    if (data?.disableLobby == true) {
                        dispatch(toggleLobbyMode(false));

                        if (getLocalParticipant.id != "local") {
                            // To inform if any other user present in the room
                            socketEmit('moderator_grant', {
                                location: roomUrl_,
                                disableLobby: false,
                                time: 1000,
                                teacherAccess: true,
                                jitsiId: getLocalParticipant.id,
                                moderatorAccess: false,
                                joinedUser: getLocalParticipant.id
                            });
                        }
                    } else if (data?.moderatorAccess == true) {
                        if (data.jitsiId != getLocalParticipant.id && getLocalParticipant.role == PARTICIPANT_ROLE.MODERATOR && tokenDecodedData.teacher == true) {
                            dispatch(toggleLobbyMode(true));
                            setTimeout(function () {
                                dispatch(grantModerator(data.jitsiId));
                            }, 3000)
                        }
                    } else if (data?.joinedUser != undefined) {
                        if (data.jitsiId != getLocalParticipant.id && conferenceJoined == false) {
                            dispatch(setTeacherWillWait(messages.teacherWillWait))
                        }
                    }
                }
            } else {
                if (lobbyEnabled && (roomUrl === location || (data?.isAudioGhost && data.userType == "Recorder")) && localParticipantRole == 'moderator') {
                    // DISABLE LOBBY
                    this.setState({ lobbyEnabled: false });
                    dispatch(toggleLobbyMode(false));
                    setTimeout(function () {
                        socketEmit('moderator_disable_lobby', {
                            location: roomUrl,
                            isGhost: true
                        });
                    }, eventTimer)
                }
            }
        });

        // STEP 2 - AUDIO GHOST USER HANDLING TO CONTROL LOBBY DISABLE BY MODERATOR
        socketOn("moderator_disable_lobby_return", (data) => {
            const { location } = data;
            const { dispatch, conferenceJoined, getLocalParticipant } = this.props;
            var roomUrl = CURRENT_ROOM_LOCATION;

            if (roomUrl === location || (data?.isGhost == true)) {
                if (!conferenceJoined) {
                    // const data = {
                    //     conferenceJoined: true
                    // };
                    // dispatch(setConferenceJoined(data));
                }

                let this_ = this;
                setTimeout(() => {
                    const { _iAmRecorder } = this_.props;
                    if (!_iAmRecorder) {
                        socketEmit("moderator_enable_lobby", {
                            location: roomUrl,
                            jitsiId: getLocalParticipant.id,
                            _iAmRecorder
                        });
                    }
                    //this.setState({ lobbyEnabled: true });
                    //dispatch(toggleLobbyMode(true));
                }, 5000);
            }
        });

        // STEP 3 - AUDIO GHOST USER HANDLING TO CONTROL LOBBY DISABLE BY MODERATOR (Grant audio ghost to moderator and disable lobby)
        socketOn("moderator_enable_lobby_return", (data) => {
            const { location, jitsiId } = data;
            const { dispatch, conferenceJoined, roomorIpAddress, localParticipantRole, lobbyStatus } = this.props;
            // var roomUrl = Constant.App.BaseUrl + roomorIpAddress;
            let roomUrl = CURRENT_ROOM_LOCATION;

            if (roomUrl === location && localParticipantRole == 'moderator' || (data?.typeIsRecorder == true)) {
                if (jitsiId && conferenceJoined) {
                    // dispatch(grantModerator(jitsiId));
                }

                let _this = this;
                // ENABLE LOBBY
                if (data.hasOwnProperty("typeIsRecorder")) {
                    setTimeout(() => {
                        _this.setState({ lobbyEnabled: true, isLobbyDisabledRequested: false });
                        // Check if previous lobby is enabled by manual or by admin entry
                        if (lobbyStatus) {
                            dispatch(toggleLobbyMode(true));
                        }

                        if (data.hasOwnProperty("userName")) {
                            if (data?.typeIsRecorder == true) {
                                // dispatch(toggleLobbyMode(true));
                            }

                            setTimeout(function () {
                                dispatch(setAudioGhostConnect(false));
                            }, 3000)
                        }
                    }, 8000);
                }
            }
        });
        socketOn("recording_status_return", (data) => {
            const { roomorIpAddress, recIpAddress, recTimeStamp, recordingStarted } = getStore(FEATURE_CUSTOM_REDUX);
            const { dispatch, localParticipantRole, getLocalParticipant, recordingModalCount } = this.props;
            let domain = window.location.origin;
            let localRoom = CURRENT_ROOM_NAME;

            console.log("recording status retured from moderator ", data)
            // if (localRoom) {
            //     localRoom = localRoom.substring(1);
            // }

            if ((data.location == domain || data.location == domain + "/" + data.roomName)
                && (data.roomName == roomorIpAddress || data.roomName == localRoom)
            ) {
                if (data.status == true) {
                    if (localParticipantRole == PARTICIPANT_ROLE.MODERATOR) {
                        if (data.hasOwnProperty("count")) {
                            dispatch(setRecordingModalCount(data.count))
                        }
                        let recCount = recordingModalCount || 0;
                        let recTime = this.recTimeCalculator(data.timestamp, recCount + 1)
                        let currentTime = Date.now()
                        let timeDiff = Math.abs((recTime.getTime() - currentTime) / 1000)

                        if (!data.hasOwnProperty("count")) {
                            data.count = 0;
                        }
                        this.intervalHandler(data)
                    }
                }
            }

            if ((data.location == domain || data.location == domain + "/" + data.roomName)
                && (data.roomName == roomorIpAddress || data.roomName == localRoom)
                && data?.jitsiId != getLocalParticipant.id
            ) {

                if (data?.type == 2) {

                }
                // if (localParticipantRole == PARTICIPANT_ROLE.MODERATOR){
                if ((recIpAddress == '' || recIpAddress == undefined) && (recTimeStamp == '' || recTimeStamp == undefined)) {
                    dispatch(setRecording({
                        recIpAddress: data.roomName,
                        recTimeStamp: data.timestamp
                    }));
                } else {
                    if (data.timestamp > recTimeStamp) {
                        dispatch(setRecording({
                            recIpAddress: data.roomName,
                            recTimeStamp: data.timestamp
                        }));
                    }
                }
                if (data.status == true) {
                    if (data.hasOwnProperty("recordingStarted")) {
                        if (data.recordingStarted != recordingStarted) {
                            dispatch(setStemRecording(data.stemStatus));
                        } else {
                        }
                    } else {
                        dispatch(setStemRecording(data.stemStatus));
                    }
                }
                if (data.status == false) {
                    if (localParticipantRole == PARTICIPANT_ROLE.MODERATOR) {
                        dispatch(stopRecording({
                            recordingStopped: true
                        }));
                    }
                    this.setState({
                        localTimeStarted: false
                    })
                }
                // }
            }
        })

        socketOn("device_user_return", (data) => {
            const { getLocalParticipant, roomorIpAddress, devicesUsers, dispatch } = this.props;
            if (data.jitsiId != getLocalParticipant.id && (data.roomName == roomorIpAddress || data.roomName == CURRENT_ROOM_NAME) && data.location == window.location.origin) {
                if (data?.isLeft == true) {
                    dispatch(setStemRecording(false))
                } else
                    if (!devicesUsers) {
                        dispatch(setDeviceUsers(data.device_user))
                    }
            }
        })

        // DUET
        socketOn("user_joined_return", (data) => {
            if (data.auth) {
                try {
                    const { tokenDecodedData } = this.props;
                    let jwt = jwt_decode(data.auth);
                    if (jwt.userID == tokenDecodedData.userid) {

                        let setData = data;
                        setData.token = setData.auth;
                        localStorage.setItem("auth", JSON.stringify(setData))
                        dispatch(setDuetUserId(data))
                    }
                } catch (e) {
                    console.log('user_joined_return error =>', e)
                }
            }

            if (data.hasOwnProperty("users")) {
                this.setSecondModerator(data.users)
                APP.store.dispatch(setRoomUsers(data.users))
            }
        })

        socketOn("secondary_moderator_rights_granted_return", (data) => {
            if (data.hasOwnProperty("users")) {
                this.setSecondModerator(data.users)
                APP.store.dispatch(setRoomUsers(data.users))
            }
        })

        socketOn("secondary_moderator_rights_revoked_return", (data) => {
            if (data.hasOwnProperty("users")) {
                this.setSecondModerator(data.users)
                APP.store.dispatch(setRoomUsers(data.users))
            }
        })

        let _this_ = this;
        setTimeout(function () {
            try {
                const { conferenceJoined, tokenDecodedData } = _this_.props;
                const { authTokenStatus } = _this_.state
                if (authTokenStatus == "join" && tokenDecodedData.teacher == true && conferenceJoined == false) {
                    window.location.reload()
                }
            } catch (e) {
                console.log('setTimeout window.location.reload() error =>', e)
            }
        }, 17000)

        // Check if teacher is joined or not after some time
        let _This = this;
        setInterval(function () {
            const { getLocalParticipant, conferenceJoined, userLoginData } = _This.props
            let userid = getLocalParticipant.id;
            if (userLoginData?.isRoomClaimed && conferenceJoined == true) {
                statsEmitter?.subscribeToClientStats(userid, _This._onStatsUpdated);
                _This.setState({
                    connectionMessage: false
                })
            }
        }, 5000)

        socketOn("room_owner_disconnect", (data) => {
            const { roomorIpAddress, authOrganization, userLoginData, conferenceJoined } = this.props;
            let { internetLostPopup } = this.state;
            if (internetLostPopup) {
                if (userLoginData?.isRoomClaimed && userLoginData.isAdmin == false && conferenceJoined == true) {
                    if (data.roomName == roomorIpAddress && data.organization == authOrganization?.name && data.organization_id == authOrganization?._id) {
                        this.startTimer();
                    }
                }
            }
        })

        socketOn("room_owner_reconnect", (data) => {
            const { roomorIpAddress, authOrganization, userLoginData } = this.props;
            if (userLoginData?.isRoomClaimed) {
                if (data.roomName == roomorIpAddress && data.organization == authOrganization?.name && data.organization_id == authOrganization?._id) {
                    this.setState({
                        connectionErrorMessage: false
                    })
                    clearInterval(this.timer)
                }
            }
        })

        socketOn("music_mode_internet_lost_return", (data) => {
            if (data.room == CURRENT_ROOM_NAME && data.location == window.location.origin) {
                this.setState({
                    internetLostPopup: false
                })

                // Bypass Pre-Joining screen in music mode process
                sessionStorage.setItem("musicModeTimer", Math.round(new Date().getTime() / 1000))
            }
        })

        socketOn("user_hangup_api_event_return", (data) => {
            if (data.roomName == CURRENT_ROOM_NAME) {
                if (data.userHangupStatus == "end" || data.userHangupStatus == "") {
                    this.setState({
                        internetLostPopup: true
                    })
                } else if (data.userHangupStatus == "leave") {
                    this.setState({
                        internetLostPopup: false
                    })
                    if (data.tokenDecodedData) {
                        if (data.tokenDecodedData?.teacher) {
                            APP.store.dispatch(disconnect(true));
                            window.location.href = window.location.origin;
                        }
                    }
                } else if (data.userHangupStatus == "allLeaveRoom") {
                    this.setState({
                        internetLostPopup: false
                    })
                    APP.store.dispatch(disconnect(true));
                    window.location.href = window.location.origin;
                }
            }
        })
        // END
    }

    // CUSTOM
    startTimer() {
        this.setState({
            conferenceKickTimer: CONFERENCE_KICK_TIMER,
            connectionErrorMessage: true,
            errorMessage: ct("Translate.InternetGone.conferenceBeforeKickMessage"),
            connectionErrorMessageType: ""
        })

        let _this = this;
        this.timer = setInterval(() => {
            _this.countDown()
        }, 1000);
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let conferenceKickTimer = this.state.conferenceKickTimer;

        if (conferenceKickTimer > 0) {
            conferenceKickTimer--;
        }

        this.setState({
            conferenceKickTimer
        });

        // Check if we're at zero.
        if (conferenceKickTimer == CONFERENCE_KICK_TIMER_BREAK) {
            this.setState({
                errorMessage: ct("Translate.InternetGone.conferenceBreakKickMessage"),
                connectionErrorMessage: true,
                connectionErrorMessageType: ""
            })
        }

        if (conferenceKickTimer == 0) {
            this.setState({
                errorMessage: ct("Translate.InternetGone.conferenceKickMessage"),
                connectionErrorMessage: true,
                connectionErrorMessageType: ""
            })

            setTimeout(() => {
                let socialAllowed = getBaseConfig("socialAllowed");
                if (socialAllowed == true) {
                    if (isSocialMobileApp()) {
                        window.parent.location.href = getBaseConfig("appReferrerUrl");
                    } else {
                        window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
                    }
                } else {
                    window.location.href = window.location.origin;
                }
            }, 5000)
        }
    }

    _onStatsUpdated(stats = {}) {
        try {
            let _This = this;
            setTimeout(() => {
                let { conferenceJoined } = _This.props;
                let { connectionMessage } = _This.state;

                if (connectionMessage == false) {
                    _This.setState({
                        connectionMessage: true
                    })

                    let { connectionQuality } = stats;
                    let newPercentageState = typeof connectionQuality === 'undefined'
                        ? {} : { percent: connectionQuality };
                    let newStats = Object.assign(
                        {},
                        stats,
                        newPercentageState);

                    setTimeout(() => {
                        let { bandwidthShow, showBandwidthModal } = _This.state;
                        if (newStats.percent != 0 && newStats.percent < ALLOWED_CONNECTION) {
                            // if (newStats.percent < ALLOWED_CONNECTION) {
                            if (conferenceJoined == true) {
                                if (bandwidthShow && showBandwidthModal) {
                                    _This.setState({
                                        connectionErrorMessage: true,
                                        connectionErrorMessageType: "bandwidth",
                                        errorMessage: ct("Translate.InternetGone.lowBandwidth")
                                    })
                                }
                            }
                        }
                    }, 50000)
                }
            }, 10000)
        } catch (error) {
            console.log('_onStatsUpdated error =>', error)
        }
    }

    setSecondModerator(users) {
        const { getLocalParticipant, dispatch } = this.props;
        let setValue = false;

        if (users.length) {
            for (let i = 0; i < users.length; i++) {
                if (users[i].jitsiUserId == getLocalParticipant.id) {
                    setValue = users[i].secondaryModerator;
                    break;
                }
            }
        }

        dispatch(setStudentSecondModerator(setValue))
    }

    setWaitinStatus(status) {
        if (status == true) {
            this.setState({
                authTokenStatus: "join"
            })
            _startConference(11);
        }
    }

    musicModeCalculation() {
        let willDisconnect = true;
        let hasMusicRoom = sessionStorage.getItem("claimedUserD");
        if (hasMusicRoom) {
            try {
                let musicUserDetail = JSON.parse(hasMusicRoom);
                if (musicUserDetail?.roomName && musicUserDetail?.roomLocation && musicUserDetail?.time) {
                    if (calculateTimeDiff(musicUserDetail.time, messages.musicModeTimeLimit)) {
                        if (CURRENT_ROOM_LOCATION == musicUserDetail.roomLocation) {
                            willDisconnect = false;
                        }
                    }
                }
            } catch (e) {
                console.log('musicModeCalculation claimedUserD error =>', e)
            }
        }

        let hasMusicModeRoom = localStorage.getItem("musicModeUser");
        if (hasMusicModeRoom) {
            try {
                let _musicUserDetail = JSON.parse(hasMusicModeRoom);
                if (_musicUserDetail?.roomName && _musicUserDetail?.roomLocation && _musicUserDetail?.time) {
                    if (calculateTimeDiff(_musicUserDetail.time, messages.musicModeTimeLimit)) {
                        if (CURRENT_ROOM_LOCATION == _musicUserDetail.roomLocation) {
                            willDisconnect = false;
                        }
                    }
                }
            } catch (e) {
                console.log('musicModeCalculation musicModeUser error =>', e)
            }
        }
        return willDisconnect;
    }

    recTimeCalculator(time, interval) {
        let newTime = new Date(time + interval * 60000)
        return newTime;
    }

    timeoutHandler(j, timerArray) {
        let { recordingModalCount } = getStore(FEATURE_CUSTOM_REDUX_V2)
        let number = recordingModalCount + 1;
        let showPop = true;
        let _this = this;

        if (timerArray[j] != undefined) {
            setTimeout(function () {
                let { recordingStarted, recordingStopped } = getStore(FEATURE_CUSTOM_REDUX)
                if (recordingStarted != 1 && recordingStopped != false) {
                    showPop = false;
                }
                let modalInput = {
                    toastModal: "",
                    modalText: "",
                }

                let modalAction = "";
                if (showPop == true) {
                    if (number == 1) {
                        modalInput.toastModal = false;
                        modalAction = "continue";
                    } else if (number == 2) {
                        modalInput.toastModal = true;
                        modalInput.modalText = ct("Translate.recording.twoHours");
                        modalInput.toastSubmitFunction = "continueRecording";
                        modalInput.toastCancelFunction = "stopRecording";
                    } else if (number == 3) {
                        modalInput.toastModal = true;
                        modalInput.modalText = ct("Translate.recording.threeHours");
                        modalInput.toastSubmitFunction = "continueRecording";
                        modalInput.toastCancelFunction = "stopRecording";
                    } else if (number == 4) {
                        modalInput.toastModal = true;
                        modalInput.modalText = ct("Translate.recording.fourHours");
                        modalInput.toastSubmitFunction = "continueRecording";
                        modalInput.toastCancelFunction = "stopRecording";
                    } else if (number == 5) {
                        modalInput.toastModal = true;
                        modalInput.modalText = ct("Translate.recording.fiveHours");
                    }

                    dispatch(setRecordingModalAction(modalAction))
                    dispatch(setRecordingModalCount(number))
                    dispatch(showToastPopup(modalInput))

                    setTimeout(() => {
                        let { recordingModalAction } = getStore(FEATURE_CUSTOM_REDUX_V2);
                        if (recordingModalAction == '') {
                            let ModalHandlerInst = ModalHandler
                            ModalHandlerInst["autoStopRecording"]();
                        }
                    }, 10000)

                    if (recordingStarted == 1 && recordingStopped == false) {
                        _this.timeoutHandler(j, timerArray)
                    }
                }
            }, timerArray[j])
            j++;
        }
    }

    intervalHandler(data) {
        let {
            localTimeStarted
        } = this.state;

        if (!localTimeStarted) {
            this.setState({
                localTimeStarted: true
            })

            let { count, recordingTimer } = data;
            let lapTimer = 60 * 1000 * 60;
            let time = new Date().getTime();
            let noInform = 5;
            let remainInform = (noInform - count);
            let timerArray = new Array(remainInform);
            let recTimer = recordingTimer * 1000;

            for (let i = 0; i < remainInform; i++) {
                if (i == 0) {
                    let initTimer = lapTimer - (Math.abs(time - recTimer));
                    timerArray[0] = initTimer
                } else {
                    timerArray[i] = lapTimer
                }
            }

            this.timeoutHandler(0, timerArray)
        }
    }

    saveLogs() {
        let killProcess = false;
        let payload = [];
        let token;
        let decoded;
        let roomName = CURRENT_ROOM_NAME;
        payload.push("roomname=" + roomName)
        if (sessionStorage.getItem("foundToken")) {
            token = sessionStorage.getItem("foundToken");
            payload.push("token=" + token)

            try {
                decoded = jwt_decode(token);
                if (decoded.teacher == true) {
                    killProcess = true
                }
            } catch (e) {
                console.log('saveLogs error =>', e)
            }
        }

        try {
            let _this = this;
            let jid;
            setTimeout(async function () {
                jid = _this.props?.getLocalParticipant?.id;
                saveDuetLog({
                    token,
                    message: "user connected",
                    type: 10,
                    domain: window.location.origin,
                    origin: window.location.href,
                    decoded,
                    jitsiId: jid,
                    userLoginData: _this.props.userLoginData,
                    publicIp: await getPublicIp(),
                    roomName: CURRENT_ROOM_NAME
                })
            }, 3000)
        } catch (e) {
            console.log('saveDuetLog error =>', e)
        }

        return {
            killProcess: killProcess,
            token: token,
            decoded: decoded,
            payload: payload
        }
    }

    async saveUnClaimedRoom() {
        if (getBaseConfig("saveUnClaimedRoom")) {
            let {
                userLoginData,
                authOrganization
            } = this.props;

            let user_id = userLoginData?.user.id;
            let name = userLoginData.user?.username;
            let email = userLoginData.user?.email;
            let organization_id = authOrganization?._id;
            if (user_id && name && organization_id) { // Removed email check to handle phone no. signup case
                let payload = {
                    user_id,
                    groupName: CURRENT_ROOM_NAME,
                    name,
                    email,
                    organization_id
                }
                await saveUnClaimedRoomReq(payload)
            }
        }
    }

    // Get user registered devices IP which can be remotely IP
    async getAvailabeUserIp() {
        let publicIp = await getPublicIp();
        let payld = {
            device_ip: publicIp
        }
        let roomStatusRes = await getDeviceStatus(payld);
        const { dispatch } = this.props;

        if (roomStatusRes.status == 1) {
            let roomStatus = roomStatusRes;
            if (roomStatus?.is_multiple) {
                let user_ip_list = roomStatus.data.map(e => e.device_ip);
                dispatch(setAvilableUserIP(user_ip_list))
            }
        }
    }


    enableMicVideo(from = 1) {
        console.log("from from mute ", from)
        dispatch(setAudioMuted(false));
        dispatch(muteLocal(false, MEDIA_TYPE.AUDIO))
        dispatch(setVideoMuted(false));
        dispatch(setVideoMuted(false, "video", VIDEO_MUTISM_AUTHORITY.USER, true));
    }

    // START: Check room session and fire user added
    checkRoomSession(hitType) {
        console.log("checkRoomSession 1 =>", hitType)
        const { roomSessionInterval } = this.state
        console.log("checkRoomSession 2 =>", roomSessionInterval)
         // when conference has many particiant
        // then thier length change after milisec
        // suppose we have 5 users in conference and 6th user join conference
        // it will get know user length has changed on didUpdate
        // prev 1 next 2, prev 2 next 3 .... next 6
        // and this happend in miliseconds, so to prevent this we have set state with if prev event time is greater than 3sec or time is zero
        // if time diff is less than 3 then functionality will stop
        //calculateTimeDiff this our custom made function
        let sessionIntervalTimer = calculateTimeDiff(roomSessionInterval.time, 3)
        console.log("checkRoomSession 3 =>", roomSessionInterval.status, sessionIntervalTimer)
        if (roomSessionInterval.status && sessionIntervalTimer) {
            console.log("checkRoomSession 4 =>")
            return false;
        }
        console.log("checkRoomSession 5 =>")
        let thiss = this;
        this.setState({
            roomSessionInterval: {
                status: true,
                time: Math.round(new Date().getTime() / 1000)
            }
        })
        if (thiss.props?.userLoginData?.isRoomClaimed && thiss.props.conferenceJoined) {
            let sessionTimer = thiss.props?.userLoginData?.isAdmin ? 0 : Math.round(Math.random() * 2000) + 10000;
            console.log("sessionTimer =>", sessionTimer)
            setTimeout(async () => {
                try {
                    let checkRoomSession = await checkRoomSessionApi({
                        room_id: thiss.props?.userLoginData?.room?._id,
                        organization_id: thiss.props?.authOrganization?._id,
                        isAdmin: thiss.props?.userLoginData?.isAdmin
                    })

                    if (checkRoomSession.status == 1) {
                        let checkRoomSessionType = checkRoomSession.data.type
                        if (checkRoomSessionType == 1) {
                            console.log("Type 1 received =>")
                        }

                        if (checkRoomSessionType == 2) {
                            console.log("Type 2 received =>")
                            let userPosition = {
                                basicInfo: {}
                            }
                            let resp = await getUserLocation();
                            userPosition.basicInfo = resp.basicInfo;

                            let obj = {
                                userId: thiss.props?.userLoginData?.user?.id,
                                isAdmin: thiss.props?.userLoginData?.isAdmin,
                                name: thiss.props?.userLoginData?.user.username,
                                email: thiss.props?.userLoginData?.user.email,
                                roomName: CURRENT_ROOM_NAME,
                                socketId: localStorage.getItem('socketId'),
                                organization_id: thiss.props?.authOrganization?._id,
                                organization: thiss.props?.authOrganization?.name,
                                jitsiId: thiss.props?.getLocalParticipant.id,
                                ...userPosition.basicInfo
                            };
                            socketEmit("user_added", obj);
                        }
                    }
                } catch (e) {
                    console.log("checkRoomSessionApi error =>", e)
                }
            }, sessionTimer)
        }
    }
    // END: Check room session and fire user added

    // END

    /**
     * Calls into legacy UI to update the application layout, if necessary.
     *
     * @inheritdoc
     * returns {void}
     */
    componentDidUpdate(prevProps) {

        // CUSTOM
        const {
            dispatch,
            isConnectedAudioGhost,
            userLoginData,
            isModerator,
            conferenceJoined,
            roomorIpAddress,
            getLocalParticipant,
            _showLobby,
            delayPanning,
            additionalDelay,
            usersData,
            stemRecording,
            isRecording,
            isStereoChanged,
            audioChannelConfig,
            tokenDecodedData,
            authOrganization,
            participantCount,
            screenview,
            isChatOpen,
            isParticipantsPaneOpen,
            audioGhostId
        } = this.props;
        var _this = this;

        // AUDIO GHOST requesting to moderator to disable the lobby (event name may be different)
        if (prevProps.delayPanning != delayPanning) {
            this.setState({
                selectedPrevPanConf: prevProps.delayPanning
            })
        }

        if (prevProps.getLocalParticipant.name != getLocalParticipant.name) {
            setTimeout(() => {
                if (!getLocalParticipant.name || getLocalParticipant.name == "" || getLocalParticipant.name == undefined || getLocalParticipant.name == "undefined") {
                    if (conferenceJoined) {
                        filterRemoteParticipant()
                    }
                }
            }, 5000)
        }

        let defaultView = getBaseConfig("defaultTileView");
        if (prevProps.participantCount != participantCount) {
            if (screenview == '') {
                APP.store.dispatch(setTileView(defaultView));
            }

            // START: Check room session and fire user added
            if (participantCount > prevProps.participantCount) {
                if (userLoginData?.isRoomClaimed) {
                    this.checkRoomSession(1);
                }
            }
            // END: Check room session and fire user added
        }

        if (prevProps.conferenceJoined !== conferenceJoined) { // && this.state.modCount
            // Disconnect user from prejoin screen and connect with actual room
            const { prejoinScreenDetail, showDevicePreConnection } = this.props;

            this.saveUnClaimedRoom();
            if (conferenceJoined) {
                // this.enableMicVideo(2);
                dispatch(setPrejoinPageVisibility(false, 5))

                if (document.getElementById("launcher")) {
                    if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                        document.getElementById("launcher").style.display = '';
                    } else {
                        document.getElementById("launcher").style.display = 'none';
                    }
                }

                // Enable lobby by room owner
                if (userLoginData?.room && userLoginData?.isAdmin && userLoginData?.room?.user_id == userLoginData?.user?.id) {
                    dispatch(toggleLobbyMode(true))
                    setTimeout(function () {
                        dispatch(toggleLobbyMode(true))
                    }, 3000)
                }

                // Check available user device ip
                this.getAvailabeUserIp()

                dispatch(getMySubscription(null, "Conference joined"));
                delete window.isDeviceConnected;
                delete window.isPreJoinChecking;
                if (prejoinScreenDetail.isSet) {
                    dispatch(setTourGuideType(tourGuideActions.WITH_DEVICE))
                    dispatch(setIsEventRequestingLoader('device-disconnect'))
                    setTimeout(function () {
                        dispatch(setIsEventRequestingLoader(''))
                    }, 20000);

                    const data = {
                        action: {
                            uniqueID: this.props.uniqueId,
                            ipAddress: prejoinScreenDetail.roomname,
                            protocolId: this.props.protocolId,
                        },
                        content: 'unpair-device',
                        isBroadcast: true,
                        sender: 'mobile',
                        scope: "conference-joined-unpair"
                    }

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: data.content,
                        requestData: data,
                        responseData: '',
                        userId: '',
                        boxId: data.action.uniqueID,
                        message: 'Emit to server'
                    }

                    SaveLog(log_data);
                    //-------------------------------------------

                    sendData(data);

                    setTimeout(async function () {
                        await makeHostRoomStatus();
                    }, 10)

                    for (var i = 1; i <= 8; i++) {
                        (function (index) {
                            setTimeout(async function () {
                                await makeHostRoomStatus();
                            }, i * 1000);
                        })(i);
                    }

                    setTimeout(async function () {
                        await makeHostRoomStatus();
                    }, 10000)

                } else {
                    dispatch(setTourGuideType(tourGuideActions.WITHOUT_DEVICE))
                    if (window.isPreJoinChecking) {
                        delete window.isPreJoinChecking;
                    }
                }

                if (window.isDeviceConnected) {
                    delete window.isDeviceConnected;
                }

                // Conference up time when user is connect in conference
                let now_time = Math.round(new Date().getTime() / 1000);
                sessionStorage.setItem("up_time_" + CURRENT_ROOM_NAME, now_time)

                setInterval(function () {
                    let _now_time = Math.round(new Date().getTime() / 1000);
                    let hasPrevTm = sessionStorage.getItem("up_time_" + CURRENT_ROOM_NAME);
                    if (hasPrevTm) {
                        sessionStorage.setItem("up_time_" + CURRENT_ROOM_NAME, _now_time)
                    }
                }, 10000)
                let cur_this = this;
                setTimeout(async () => {

                    let userPosition = {
                        basicInfo: {}
                    }
                    let resp = await getUserLocation();
                    userPosition.basicInfo = resp.basicInfo;

                    // if room is claimed then add event by admin side, room owner
                    if (cur_this.props?.userLoginData?.room) {
                        let isAdmin = false;

                        if (cur_this.props?.userLoginData?.room?.user_id == cur_this.props?.userLoginData?.user?.id) {
                            isAdmin = true
                        }

                        let obj = {
                            userId: cur_this.props?.userLoginData?.user?.id,
                            isAdmin: isAdmin,
                            name: cur_this.props?.userLoginData?.user.username,
                            email: cur_this.props?.userLoginData?.user.email,
                            roomName: CURRENT_ROOM_NAME,
                            socketId: localStorage.getItem('socketId'),
                            organization_id: cur_this.props?.authOrganization?._id,
                            organization: cur_this.props?.authOrganization?.name,
                            jitsiId: getLocalParticipant.id,
                            ...userPosition.basicInfo
                        };
                        socketEmit("user_added", obj);
                    } else {
                        let obj = {
                            userId: cur_this.props?.userLoginData?.user?.id,
                            isAdmin: false,
                            name: cur_this.props?.userLoginData?.user?.username,
                            email: cur_this.props?.userLoginData?.user?.email,
                            roomName: CURRENT_ROOM_NAME,
                            socketId: localStorage.getItem('socketId'),
                            organization_id: cur_this.props?.authOrganization?._id,
                            organization: cur_this.props?.authOrganization?.name,
                            jitsiId: getLocalParticipant.id,
                            ...userPosition.basicInfo
                        };
                        socketEmit("user_added", obj);
                    }
                })

                // START: Check room session and fire user added
                if (userLoginData?.isRoomClaimed && !userLoginData?.isAdmin) {
                    this.checkRoomSession(2);
                }
                // END: Check room session and fire user added

                const { prejoinScreenUserRoute } = this.props;

                if (prejoinScreenUserRoute == InvitedUserConfirmFlag.WITH_DEVICE && getBaseConfig("showPreJoiningInConference")) {
                    dispatch(setShowDevicePreConnection(true));
                }
            }
            // end conferene joined

            // Get organization for white board or other api
            APP.store.dispatch(getOrganizationList())

            if (defaultView && this.props.participantCount > 1) {
                APP.store.dispatch(setTileView(defaultView));
            }

            setTimeout(function () {
                filterRemoteParticipant()
            }, 2000)

            // Remove music mode storage
            if (tokenDecodedData) {
                if (tokenDecodedData.student) {
                    sessionStorage.removeItem("claimedUserD");
                }
            }

            // Save DUET joined users
            this.saveLogs()

            setTimeout(function () {
                sessionStorage.removeItem("claimedUserD");
            }, 12000)

            // Check if recording is already enabled
            var _t_this = this;
            setTimeout(function () {
                const recEnable = _t_this.props.isRecording;
                if (recEnable && recEnable > 0) {
                    try {
                        let hasRecSession = sessionStorage.getItem("rec_session");
                        let _data = JSON.parse(hasRecSession);
                        if (_data.location == CURRENT_ROOM_LOCATION) {
                            if (calculateTimeDiff(_data.t, 120)) {
                                APP.store.dispatch(setRecording({
                                    recIpAddress: _data.recIpAddress,
                                    recTimeStamp: _data.recTimeStamp,
                                    isStored: true
                                }))
                            }
                        }
                    } catch (e) {
                        console.log("rec_session error =>", e)
                    }
                }
            }, 2000)

            // DUET teacher student
            var {
                authTokenStatus,
                studentWillWait
            } = this.state;

            if (studentWillWait == true) {
                let joinData = tokenDecodedData;
                joinData.organization_id = authOrganization?._id;
                joinData.organization = authOrganization.domain;
                joinData.jitsiId = getLocalParticipant.id;

                socketEmit("user_joined", joinData);

                let _roomUrl = CURRENT_ROOM_LOCATION;
                let _this1 = this;
                if (authTokenStatus == "join" && tokenDecodedData.teacher == true) {
                    setTimeout(function () {
                        if (_this1.state.musicModeStatusChange == false) {
                            dispatch(toggleLobbyMode(true));
                        }
                    }, 4000)
                    setTimeout(function () {
                        socketEmit('moderator_grant', {
                            location: _roomUrl,
                            disableLobby: false,
                            time: 1000,
                            teacherAccess: true,
                            jitsiId: getLocalParticipant.id,
                            moderatorAccess: true
                        });
                    }, 6000)

                    setTimeout(function () {
                        if (_this1.state.musicModeStatusChange == true) {
                            dispatch(toggleLobbyMode(true));
                            _this1.setState({
                                musicModeStatusChange: false
                            })
                            // Re-enable lobby if not enable in first time
                            setTimeout(function () {
                                dispatch(toggleLobbyMode(true));
                            }, 5000)
                        }
                    }, 45000)
                    // If music mode enable/disble in case of duet, the lobby will enable after 45sec,let student to enter in the room
                }
            }

            // Send event to all users, after music mode on/off, when moderator is joined
            if (this.props?.userLoginData?.room || tokenDecodedData) {
                try {
                    let moderatorDetail = JSON.parse(sessionStorage.getItem("claimedUserD"));
                    if (moderatorDetail) {
                        if (moderatorDetail.hasOwnProperty("isModerator")) {
                            sessionStorage.removeItem("claimedUserD")
                        }
                    }
                } catch (e) {
                    console.log("claimedUserD error =>", e)
                }

                let _th_is = this;
                if (!_th_is.state.musicModeSent) {
                    _th_is.setState({
                        musicModeSent: true
                    })
                    let room_name_m = CURRENT_ROOM_LOCATION;

                    setTimeout(function () {
                        let hasMusicMode = sessionStorage.getItem("musicModeType_" + room_name_m);
                        if (hasMusicMode) {
                            try {
                                let jsonData = JSON.parse(hasMusicMode);
                                if (jsonData?.t && jsonData?.type) {
                                    let prevTim = parseInt(jsonData.t);
                                    let time = Math.round(new Date().getTime() / 1000);
                                    let diff = time - prevTim;
                                    if (diff < messages.musicModeTimeLimit) {
                                        let roomName = CURRENT_ROOM_NAME;
                                        let obj = {
                                            roomLocation: room_name_m,
                                            uid: _th_is.props.getLocalParticipant.id,
                                            location: window.location.origin,
                                            roomName
                                        };

                                        if (jsonData.type == "disableLoad") {
                                            obj.moderatorStatus = "disable";
                                        } else if (jsonData.type == "enableLoad") {
                                            obj.moderatorStatus = "enable";
                                        }

                                        _th_is.setState({
                                            musicModeStatusChange: true
                                        })

                                        // socketEmit("domiantUrl", obj);
                                        // Send event till 40 sec in 5s interval, if any user unable to connect send event will be send after and after,
                                        // Any user can be low internet
                                        for (var i = 1; i <= 8; i++) {
                                            (function (index) {
                                                setTimeout(function () {
                                                    socketEmit("domiantUrl", obj);
                                                }, i * 5000);
                                            })(i);
                                        }
                                        sessionStorage.removeItem("musicModeType_" + room_name_m)
                                    }
                                }
                            } catch (e) {
                                console.log("musicModeType_ error =>", e)
                            }
                        }
                    }, messages.musicModeSessionCheck)
                }
            }

            this.setState({ modCount: false });
            const { room, isAdmin } = userLoginData;
            let roomUrl = CURRENT_ROOM_LOCATION;

            let RecorderUser = this.props._iAmRecorder;
            setTimeout(() => {
                if (RecorderUser) {
                    let enable_lobby = {
                        location: roomUrl,
                        typeIsRecorder: true,
                        userName: getLocalParticipant?.name
                    }
                    socketEmit("moderator_enable_lobby", enable_lobby);
                }
            }, 8000);

            if (room) {
                if (room != null) {
                    if (room.groupName) {
                        socketEmit("moderator_joined", { roomName: roomorIpAddress });
                    }

                    if (isAdmin) {
                        if (getLocalParticipant.role != PARTICIPANT_ROLE.MODERATOR) {
                            socketEmit('moderator_grant', {
                                location: roomUrl,
                                jitsiUser: getLocalParticipant.id,
                                isAdminRight: true,
                                lobby: room.lobby
                            });
                        }
                    }

                    // WORKING FOR PUBLIC CLIAMED ROOM: LOBBY THING
                    if (isAdmin && isModerator) {
                        if (room.lobby) {
                            dispatch(setLobbyStatus(true));
                        }
                        dispatch(toggleLobbyMode(room.lobby));
                    }
                }
            }
            // AUDIO GHOST requesting to moderator to disable the lobby (event name may be different)
        }

        const { remoteParticipants } = this.props;  // CUSTOM
        if (prevProps.isConnectedAudioGhost !== isConnectedAudioGhost) {
            if (isConnectedAudioGhost == true) {
                dispatch(clearNotifications());
                // BIND NOTIFICATION
                dispatch(hideNotification("hybrid.init"))
                dispatch(showNotification({
                    titleKey: ct("rta-trmc.mixer.connected"),
                    descriptionKey: ct("rta-trmc.mixer.systemIsReadyNow")
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                // CUSTOM 

                if (usersData) {
                    remoteParticipants.forEach(participant => {
                        dispatch(setVolume(participant.id, 0));
                        console.log("volume down yes from 3 as ghost connected and i have device connected ", participant.id)

                    })
                    try {
                        setTimeout(() => {
                            let allAudio = document.getElementsByTagName("audio");
                            dispatch(setVolume(audioGhostId, 0));
                            console.log("volume down yes from 4 of ghost user  i have device connected ", audioGhostId)
                        }, 2000)

                    } catch (e) {
                    }
                }
                // END
            }

            if (isConnectedAudioGhost == false) {
                dispatch(clearNotifications());
                // BIND NOTIFICATION
                dispatch(showNotification({
                    titleKey: ct("rta-trmc.mixer.disconnected"),
                    descriptionKey: ct("rta-trmc.mixer.disconnectedMsg")
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                setTimeout(function () {
                    dispatch(hideNotification("hybrid.stop"))
                }, 11000)
                // CUSTOM 
                if (usersData) {
                    remoteParticipants.forEach(participant => {
                        dispatch(setVolume(participant.id, 0.8));
                        console.log("volume down no from 5 as ghost removed ", participant.id)
                    })
                }
                // END
            }
        }

        // Set the isStereo to default after 10second when user change it
        if (prevProps.isStereoChanged != isStereoChanged) {
            if (isStereoChanged == true) {
                setTimeout(function () {
                    dispatch(setAudioStereo(false))
                }, 10000)
            }
        }

        // Check if user change the audio channel from the setting tab, check if delay panning enable. so, we need to disable the delay panning as well
        if (prevProps.audioChannelConfig != audioChannelConfig) {
            if (usersData) {
                const { additionalChannelSetting, devicesUsers } = this.props;
                if (delayPanning == PANNING_VAR.DELAY_PANNING && audioChannelConfig == 0) {
                    if (additionalChannelSetting == true) {
                        let uniqueId = "";
                        if (devicesUsers?.uniqueId) {
                            uniqueId = devicesUsers.uniqueId;
                        } else if (usersData.uniqueId) {
                            uniqueId = usersData.uniqueId
                        }

                        const message = {
                            action: {
                                deviceId: uniqueId,
                                status: true,
                                room: roomorIpAddress,
                                panning_name: audioChannelConfig == 0 ? PANNING_VAR.NO_PANNING : PANNING_VAR.VOLUME_PANNING,
                                name: getLocalParticipant.name || "user",
                                jitsiId: getLocalParticipant.id
                            },
                            content: "disable-delay-panning",
                            isBroadcast: true,
                            sender: 'mobile'
                        };

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: message.action.deviceId,
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(message)
                    }
                }

                if (audioChannelConfig != 0) {
                    // Change pan status to 50%
                    AutoChangeCircleSlider(50, "i", "audio channel change from inside")
                }

                setTimeout(function () {
                    dispatch(setAudioChannelAdditionalSetting(false))
                }, 10000)
            }
        }

        // Check delay panning status
        if (prevProps.delayPanning != delayPanning) {
            if (usersData) {
                if (delayPanning == PANNING_VAR.DELAY_PANNING) {
                    var _this = this;
                    setTimeout(function () {
                        if (additionalDelay == undefined || additionalDelay == null) {
                            const message1 = {
                                action: {
                                    deviceId: usersData.uniqueId,
                                    status: true,
                                    room: roomorIpAddress,
                                    panning_name: PANNING_VAR.DELAY_PANNING,
                                    name: getLocalParticipant.name || "user",
                                    jitsiId: getLocalParticipant.id
                                },
                                content: 'enable-delay-panning',
                                isBroadcast: true,
                                sender: 'mobile'
                            };

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message1.content,
                                requestData: message1,
                                responseData: '',
                                userId: '',
                                boxId: message1.action.deviceId,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            sendData(message1)
                        }
                        // CUSTOM
                        const message = {
                            action: {
                                uniqueID: usersData.uniqueId,
                                audioChannel: 1,
                                panningName: PANNING_VAR.DELAY_PANNING
                            },
                            content: 'audio-channel',
                            isBroadcast: true,
                            sender: 'mobile'
                        };
                        // END
                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: message.action.uniqueID,
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(message)
                    }, 3000)
                } else {
                    let index = '';
                    if (additionalDelay?.jitsiId == getLocalParticipant.id || sessionStorage.getItem("c_" + roomorIpAddress)) {
                        if (sessionStorage.getItem("c_" + roomorIpAddress)) {
                            sessionStorage.removeItem("c_" + roomorIpAddress)
                        }

                        if (delayPanning == PANNING_VAR.VOLUME_PANNING) {
                            index = 1;
                        }

                        // else if (prevPanning.length > 1) {
                        //     prevPanning.pop();
                        //     index = prevPanning.pop();
                        // }

                        else {
                            index = 0;
                        }

                        // If audio channel is stereo then change to other, respectively not hit the next event if set true (stop second call of audio-channel event )
                        if (isStereoChanged == false) {
                            const message = {
                                // CUSTOM
                                action: {
                                    uniqueID: usersData.uniqueId,
                                    audioChannel: index,
                                    panningName: PANNING_VAR.VOLUME_PANNING
                                },
                                // END
                                content: 'audio-channel',
                                isBroadcast: true,
                                sender: 'mobile'
                            };

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            sendData(message)
                            // If index is 1 (it will not work in Mono mode)
                            // Change pan status to 50%
                            // if (index == 1) {
                            //     AutoChangeCircleSlider(50, index, "volume pan")
                            // }
                        }
                    }
                }

                let __this = this;
                setTimeout(function () {
                    // if ((__this.state.selectedPrevPanConf == PANNING_VAR.NO_PANNING)
                    //     && (delayPanning == PANNING_VAR.DELAY_PANNING
                    //         || delayPanning == PANNING_VAR.VOLUME_PANNING)){
                    if (delayPanning != PANNING_VAR.NO_PANNING) {
                        AutoChangeCircleSlider(50, "d", "delay pan change")
                    }
                    // }

                }, 5000)
            }
        }

        const { devicesUsers, deviceUserName } = this.props;
        if (prevProps.devicesUsers != devicesUsers) {
            if (prevProps.devicesUsers && !devicesUsers) {
                if (!usersData) {
                    if (stemRecording && isRecording > 0) {
                        dispatch(setStemRecording(false))
                    }
                }
            }
        }

        // Set default device username
        if (usersData) {
            if (prevProps.usersData?.myName != usersData?.myName) {
                setTimeout(function () {
                    dispatch(getDeviceUserName(usersData, getLocalParticipant))
                }, 2000)
            }
        }

        const { authVerifyToken, teacherWaitTimer } = this.props;
        if (!isEqual(prevProps.authVerifyToken, authVerifyToken)) {
            this.setState({
                authTokenStatus: authVerifyToken?.type
            })
            if (authVerifyToken?.type == "join") {
                setTimeout(function () {
                    _startConference(10);
                }, teacherWaitTimer)
            }
        }

        if (prevProps._showLobby != _showLobby) {
            if (_showLobby) {
                let killProcess = false;
                let payload = [];
                let token;
                let decoded;
                let roomName = CURRENT_ROOM_NAME;
                payload.push("roomname=" + roomName)
                if (sessionStorage.getItem("foundToken")) {
                    token = sessionStorage.getItem("foundToken");
                    payload.push("token=" + token)
                    try {
                        decoded = jwt_decode(token);
                        if (decoded.teacher == true) {
                            killProcess = true
                        }
                    } catch (e) {
                        console.log("foundToken error =>", e)
                    }
                }

                try {
                    saveDuetLog({
                        token,
                        message: "lobby issue",
                        type: 4,
                        domain: window.location.origin,
                        origin: window.location.href,
                        decoded
                    })
                } catch (e) {
                    console.log("saveDuetLog error =>", e)
                }

                // if (userLoginData?.isAdmin) {
                //     killProcess = true
                // }

                payload.push("organization_id=" + authOrganization?._id)

                if (killProcess) {
                    endConferenceA("?" + payload.join("&")).then(response => {
                        if (response.status == 1) {
                            sessionStorage.removeItem("conference_time_" + roomName)
                            _startConference()
                        }
                    })
                }
            }
        }

        if ((isChatOpen && isChatOpen !== prevProps.isChatOpen) || (isParticipantsPaneOpen && isParticipantsPaneOpen !== prevProps.isParticipantsPaneOpen)) {
            this.setState({ showToolBoxPanel: false });
            let timer;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                this.setState({ showToolBoxPanel: true });
            }, 700);
        }

        // check when remote participant changed
        const { conferenceUsers } = this.props;
        if (!_.isEqual(prevProps.conferenceUsers, conferenceUsers)) {
            if (prevProps.conferenceUsers < conferenceUsers) {
                if (isConnectedAudioGhost && audioGhostId) {
                    if (usersData) {
                        remoteParticipants.forEach(participant => {
                            dispatch(setVolume(participant.id, 0));
                            console.log("volume down yes from 1 as user changed")
                        })
                    }
                }
            }
        }


        if (this.props._shouldDisplayTileView
            === prevProps._shouldDisplayTileView) {
            return;
        }

        // END

        // TODO: For now VideoLayout is being called as LargeVideo and Filmstrip
        // sizing logic is still handled outside of React. Once all components
        // are in react they should calculate size on their own as much as
        // possible and pass down sizings.
        VideoLayout.refreshLayout();
    }

    /**
     * Disconnect from the conference when component will be
     * unmounted.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.UI.unbindEvents();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.removeEventListener(name, this._onFullScreenChange));

        APP.conference.isJoined() && this.props.dispatch(disconnect());
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const {
            _layoutClassName,
            _notificationsVisible,
            _overflowDrawer,
            _showLobby,
            _showPrejoin,
            // CUSTOM
            conferenceLeft,
            showModalError,
            showModeratorModal,
            showMultiModeratorModal,
            toastModal,
            showLoader,
            conferenceJoined,
            isWaiting,
            userLoginData,
            stemRecordingUrl,
            stemRecording,
            loaderAdditionalDetail,
            alwaysShowPreJoining,
            showDevicePreConnection
            // END
        } = this.props;

        // CUSTOM
        const { isRoomStarted, isRoomClaimed } = userLoginData;
        const {
            studentWillWait,
            authTokenStatus,
            connectionErrorMessage,
        } = this.state;

        if (studentWillWait == true && authTokenStatus == "wait") {
            return <StudentWaitingPage setWaitinStatus={this.setWaitinStatus} />
        } else if (studentWillWait == true && authTokenStatus == "leave") {
            alert(ct("rta-trmc.conference.tokenNotFound"));
            window.location.href = window.location.origin;
        } else {

            // END
            return (
                <div
                    id='layout_wrapper'
                    onMouseEnter={this._onMouseEnter}
                    onMouseLeave={this._onMouseLeave}
                    onMouseMove={this._onMouseMove}
                    ref={this._setBackground}>
                    <Chat />
                    <div
                        className={_layoutClassName}
                        id='videoconference_page'
                        onMouseMove={isMobileBrowser() ? undefined : this._onShowToolbar}>
                        <ConferenceInfo />
                        <Notice />
                        <div
                            id='videospace'
                            onTouchStart={this._onVidespaceTouchStart}>
                            {/* CUSTOM: */}

                            {!conferenceJoined &&
                                <div className="d-flex align-items-center justify-content-center flex-column full-vh pl-4 pr-4">
                                    <div className="h3 mb-5">
                                        {ct("rta-trmc.conference.preparingRoom")}... <br />
                                        ({ct("rta-trmc.conference.roomNotLoaded")})
                                    </div>
                                </div>
                            }
                            <LargeVideo />
                            {
                                getBaseConfig("showDevicePreJoining") ?
                                    (_showPrejoin || _showLobby || (
                                        <>
                                            <StageFilmstrip />
                                            <ScreenshareFilmstrip />
                                            <MainFilmstrip />
                                        </>
                                    ))
                                    :
                                    <>
                                        <StageFilmstrip />
                                        <ScreenshareFilmstrip />
                                        <MainFilmstrip />
                                    </>
                            }
                        </div>
                        {/* CUSTOM */}
                        {
                            // Don't show loader when checking device status/connectivity on prejoin screen
                            showLoader && loaderAdditionalDetail && conferenceJoined == true && !showDevicePreConnection &&
                            <>
                                <div className="loader-text-container A">
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <>
                                            {getBaseConfig("showPushSpinnerLoader") ?
                                                <div className='loader-wrapper'>
                                                    <PushSpinner
                                                        size={30}
                                                        color="white"
                                                        loading={showLoader}
                                                        className={"loader-text-main"}
                                                    />
                                                    <div className={"loader-text"}>{
                                                        loaderAdditionalDetail
                                                    }</div>
                                                </div>
                                                :
                                                <Loader
                                                    loaded={!showLoader}
                                                    options={{
                                                        color: '#fff'
                                                    }}
                                                    className={"loader-text-main"}
                                                > </Loader>
                                            }
                                        </>
                                    </div>
                                </div>
                            </>
                        }

                        {
                            showLoader && !loaderAdditionalDetail && conferenceJoined == true &&
                            <>
                                {getBaseConfig("showPushSpinnerLoader") ?
                                    <div className="loader-text-container B">
                                        <div className='loader-wrapper'>
                                            <PushSpinner
                                                size={30}
                                                color="white"
                                                loading={showLoader}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <Loader
                                        loaded={!showLoader}
                                        options={{
                                            color: '#fff'
                                        }}
                                    > </Loader>
                                }
                            </>
                        }
                        {/* END */}
                        {/* CUSTOM */}
                        {
                            getBaseConfig("hidePreJoinScreen") && this.state.showToolBoxPanel && conferenceJoined && <Toolbox />
                        }
                        {_showPrejoin || _showLobby || (this.state.showToolBoxPanel && !getBaseConfig("hidePreJoinScreen") && <Toolbox />)}
                        {/* END */}
                        {_notificationsVisible && (_overflowDrawer
                            ? <JitsiPortal className='notification-portal'>
                                {this.renderNotificationsContainer({ portal: true })}
                            </JitsiPortal>
                            : this.renderNotificationsContainer())
                        }
                        {/* CUSTOM */}
                        <div id="audioHide">
                            <audio id="beepOne" src="sounds/custom-beep.mp3" preload="auto" controls="controls">Ringer !!</audio>
                        </div>
                        {/* END */}
                        <CalleeInfoContainer />

                        {_showLobby && <LobbyScreen />}

                        {/* CUSTOM */}
                        {alwaysShowPreJoining && _showPrejoin && !_showLobby && <Prejoin />}
                        {/* {_showPrejoin && <Prejoin />} */}
                        {showModalError && disconnectRoom()}
                        {showModeratorModal && <DisconnectModerator />}
                        {showMultiModeratorModal && <DisconnectMultiModerator />}
                        {<StopRecordingConference
                            stemRecordingUrl={stemRecordingUrl}
                            stemRecording={stemRecording}
                        />}
                        {toastModal && toggletoastModal()}
                        {connectionErrorMessage && this.showOwnerLeftModal()}
                        {/* END */}
                    </div>
                    <ParticipantsPane />
                </div>
            );
            // CUSTOM
        }
        // END
    }

    // CUSTOM:
    showOwnerLeftModal() {
        const confirmMsg = this.state.errorMessage;
        let { connectionErrorMessageType, bandwidthShow, showBandwidthModal } = this.state;

        return (
            <>
                {
                    showBandwidthModal &&
                    <ModalTransition>
                        <div className="host-popup">
                            <Modal
                                testId={'weak-internet-popup'}
                            >
                                <div className="end-session">
                                    <div className="titleHelpModal" id="2">
                                        <p dangerouslySetInnerHTML={{ __html: confirmMsg }}></p>
                                    </div>
                                    <div className="footer-bottom custom-modal-con w-100 justify-content-between d-flex">
                                        {
                                            connectionErrorMessageType == "bandwidth" ?
                                                <Checkbox
                                                    isChecked={!bandwidthShow}
                                                    label={"Don't show again"}
                                                    name='internet-dont-show-message'
                                                    onChange={() => {
                                                        this.setState({
                                                            bandwidthShow: !bandwidthShow
                                                        })
                                                    }}
                                                    size='large'
                                                />
                                                : <span></span>
                                        }
                                        <button className="yes-host-btn"
                                            onClick={() => {
                                                this.setState({
                                                    connectionErrorMessage: false,
                                                    connectionErrorMessageType: "",
                                                    showBandwidthModal: bandwidthShow
                                                })
                                            }}
                                        >{ct("Translate.buttonTitle.okCaps")}</button>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </ModalTransition>
                }
            </>
        )
    }
    // END

    /**
     * Sets custom background opacity based on config. It also applies the
     * opacity on parent element, as the parent element is not accessible directly,
     * only though it's child.
     *
     * @param {Object} element - The DOM element for which to apply opacity.
     *
     * @private
     * @returns {void}
     */
    _setBackground(element) {
        if (!element) {
            return;
        }

        if (this.props._backgroundAlpha !== undefined) {
            const elemColor = element.style.background;
            const alphaElemColor = setColorAlpha(elemColor, this.props._backgroundAlpha);

            element.style.background = alphaElemColor;
            if (element.parentElement) {
                const parentColor = element.parentElement.style.background;
                const alphaParentColor = setColorAlpha(parentColor, this.props._backgroundAlpha);

                element.parentElement.style.background = alphaParentColor;
            }
        }
    }

    /**
     * Handler used for touch start on Video container.
     *
     * @private
     * @returns {void}
     */
    _onVidespaceTouchStart() {
        this.props.dispatch(toggleToolboxVisible());
    }

    /**
     * Updates the Redux state when full screen mode has been enabled or
     * disabled.
     *
     * @private
     * @returns {void}
     */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }

    /**
     * Triggers iframe API mouseEnter event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseEnter(event) {
        APP.API.notifyMouseEnter(event);
    }

    /**
     * Triggers iframe API mouseLeave event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseLeave(event) {
        APP.API.notifyMouseLeave(event);
    }

    /**
     * Triggers iframe API mouseMove event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseMove(event) {
        APP.API.notifyMouseMove(event);
    }

    /**
     * Displays the toolbar.
     *
     * @private
     * @returns {void}
     */
    _onShowToolbar() {
        this.props.dispatch(showToolbox());
    }

    /**
     * Until we don't rewrite UI using react components
     * we use UI.start from old app. Also method translates
     * component right after it has been mounted.
     *
     * @inheritdoc
     */
    _start() {
        APP.UI.start();

        APP.UI.registerListeners();
        APP.UI.bindEvents();

        FULL_SCREEN_EVENTS.forEach(name =>
            document.addEventListener(name, this._onFullScreenChange));

        const { dispatch, t } = this.props;

        dispatch(connect());

        maybeShowSuboptimalExperienceNotification(dispatch, t);
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const { backgroundAlpha, mouseMoveCallbackInterval } = state['features/base/config'];
    const { overflowDrawer } = state['features/toolbox'];

    // CUSTOM
    const isModerator = isLocalParticipantModerator(state);
    const remoteParticipants = getRemoteParticipants(state)

    const remoteUser = _.flatten(Array.from(remoteParticipants));
    // all remote  + 1 current user
    let conferenceUsers = remoteUser.length;
    // END

    return {
        ...abstractMapStateToProps(state),
        _backgroundAlpha: backgroundAlpha,
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state)],
        _mouseMoveCallbackInterval: mouseMoveCallbackInterval,
        _overflowDrawer: overflowDrawer,
        _roomName: getConferenceNameForTitle(state),
        _showLobby: getIsLobbyVisible(state),
        _showPrejoin: isPrejoinPageVisible(state),

        // CUSTOM
        isModerator: isModerator,
        lobbyEnabled: state['features/lobby'].lobbyEnabled,
        showLoader: state['trmc/customLoader/modal'].showLoader,
        devices: state['features/base/devices'],
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        loaderAdditionalDetail: state['trmc/customLoader/modal'].loaderAdditionalDetail,
        isRecording: state['features/recording']?.sessionDatas?.filter(e => e.mode == "file" && e.status == "on")?.length,
        isStreaming: state['features/recording']?.sessionDatas?.filter(e => e.mode == "stream" && e.status == "on")?.length,
        getLocalParticipant: getLocalParticipant(state),
        participantCount: getParticipantCount(state),
        localParticipantRole: getLocalParticipant(state).role,
        _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        isVoiceSync: state[FEATURE_CUSTOM_REDUX].isVoiceSync,
        audioGhost: state[FEATURE_CUSTOM_REDUX].audioGhost,
        showModalError: state[FEATURE_CUSTOM_REDUX].showModalError,
        hostData: state[FEATURE_CUSTOM_REDUX].hostData,
        uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
        room: state[FEATURE_CUSTOM_REDUX].room,
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        showModeratorModal: state[FEATURE_CUSTOM_REDUX].showModeratorModal,
        showMultiModeratorModal: state[FEATURE_CUSTOM_REDUX].showMultiModeratorModal,
        conferenceLeft: state[FEATURE_CUSTOM_REDUX].conferenceLeft,
        ghostList: state[FEATURE_CUSTOM_REDUX].ghostList,
        publicIp: state[FEATURE_CUSTOM_REDUX].publicIp,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        recordingStopped: state[FEATURE_CUSTOM_REDUX].recordingStopped,
        recIpAddress: state[FEATURE_CUSTOM_REDUX].recIpAddress,
        recTimeStamp: state[FEATURE_CUSTOM_REDUX].recTimeStamp,
        showBufferLoader: state[FEATURE_CUSTOM_REDUX].showBufferLoader,
        toastModal: state[FEATURE_CUSTOM_REDUX].toastModal,
        isWaiting: state[FEATURE_CUSTOM_REDUX].isWaiting,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        isConnectedAudioGhost: state[FEATURE_CUSTOM_REDUX].isConnectedAudioGhost,
        audioGhostId: state[FEATURE_CUSTOM_REDUX].audioGhostId,
        ghostUserId: state[FEATURE_CUSTOM_REDUX].ghostUserId,
        isAutoMakeModal: state[FEATURE_CUSTOM_REDUX].isAutoMakeModal,
        isAutoMakeHostUniqueId: state[FEATURE_CUSTOM_REDUX].isAutoMakeHostUniqueId,
        lobbyStatus: state[FEATURE_CUSTOM_REDUX].lobbyStatus,
        stemRecordingUrl: state[FEATURE_CUSTOM_REDUX].stemRecordingUrl,
        stemRecording: state[FEATURE_CUSTOM_REDUX].stemRecording,
        delayPanning: state[FEATURE_CUSTOM_REDUX].delayPanning,
        prevPanning: state[FEATURE_CUSTOM_REDUX].prevPanning,
        additionalDelay: state[FEATURE_CUSTOM_REDUX].additionalDelay,
        audioChannelSt: state[FEATURE_CUSTOM_REDUX].audioChannelSt,
        additionalAudioChannel: state[FEATURE_CUSTOM_REDUX].additionalAudioChannel,
        devicesUsers: state[FEATURE_CUSTOM_REDUX].devicesUsers,
        authVerifyToken: state[FEATURE_CUSTOM_REDUX].authVerifyToken,
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        teacherWaitTimer: state[FEATURE_CUSTOM_REDUX].teacherWaitTimer,
        protocolId: state[FEATURE_CUSTOM_REDUX].protocolId,
        isStereoChanged: state[FEATURE_CUSTOM_REDUX_V2].isStereoChanged,
        audioChannelConfig: state[FEATURE_CUSTOM_REDUX_V2].audioChannelConfig,
        additionalChannelSetting: state[FEATURE_CUSTOM_REDUX_V2].additionalChannelSetting,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        screenview: state[FEATURE_CUSTOM_REDUX_V2].screenview,
        recordingModalCount: state[FEATURE_CUSTOM_REDUX_V2].recordingModalCount,
        recordingModalAction: state[FEATURE_CUSTOM_REDUX_V2].recordingModalAction,
        prejoinScreenDetail: state[FEATURE_CUSTOM_REDUX_V2].prejoinScreenDetail,
        alwaysShowPreJoining: state[FEATURE_CUSTOM_REDUX_V3].alwaysShowPreJoining,
        paidRoomDetail: state[FEATURE_CUSTOM_REDUX_V2].paidRoomDetail,
        isLogout: state[FEATURE_CUSTOM_REDUX].isLogout,
        isChatOpen: state['features/chat'].isOpen,
        isParticipantsPaneOpen: getParticipantsPaneOpen(state),
        prejoinScreenUserRoute: state[FEATURE_CUSTOM_REDUX_V3].prejoinScreenUserRoute,
        showDevicePreConnection: state[FEATURE_CUSTOM_REDUX_V3].showDevicePreConnection,
        remoteParticipants,
        conferenceUsers
        // END
    };
}

export default reactReduxConnect(_mapStateToProps)(translate(Conference));
